import { AdminRoutes } from "@src/routes/loggedIn/adminPageRoutes/adminRoutes";

export const AdminPageRoutes = [...AdminRoutes];
